import React from 'react';
import LocationPicker from 'core/locationPicker';
import { ValueType } from 'modules/queryBuilder/legacyQueryBuilder/types';
import { DEFAULT_GEO_LOCATION } from 'utils/coordinates';
import { GEO_LOCATION } from 'utils/fieldTypes';
import noop from 'utils/noop';
import {
  OrderByLocationPickerContainer,
  StyledValueTypeDropdown,
  StyledCoreDropdown,
} from './OrderByLocationPicker.styled';

// type Props = {
//   /** The dynamic location value. */
//   dynamicLocation: string,
//   /** The geo location object value. */
//   location: {},
//   /**
//    * Callback function when any value is changed.
//    *
//    * ```
//    * onChange(e, updatedProps) => {}
//    * ```
//    * @param { Object } e: The change event.
//    * @param { Object } updatedProps: The updated props with new values.
//    * @returns { void }
//    */
//   onChange: () => {},
//   /** Object of arrays of user mappings by type. */
//   userMappings: {},
// };

export default class OrderByLocationPicker extends React.Component {
  static defaultProps = {
    onChange: noop,
    userMappings: {
      [GEO_LOCATION]: [],
    },
  };

  /**
   * Returns the value type for the value field.
   * @param { Boolean } isDynamic: If the query is dynamic.
   * @returns { String } The value type,
   */
  getValueTypeDropdownValue = (isDynamic) => (isDynamic ? ValueType.Contact : ValueType.Custom);

  getDropdownOptions = () => this.props.userMappings[GEO_LOCATION];

  /**
   * getLatLonFromLocation
   * Helper function to get the lat and lon values from the location object.
   * @param { Object } location: The location object.
   * @returns { Object } Object containing lat and lon values.
   */
  getLatLonFromLocation = (location) => {
    const { lat, lon } = location || DEFAULT_GEO_LOCATION;
    return { lat, lon };
  };

  /**
   * handleChangeDynamicLocation
   * Callback function when dynamic location is changed.
   * @param { Object } e: The change event.
   * @param { Object } updatedProps: Updated props containing the updated dyanmic location value.
   * @returns { void }
   */
  handleChangeDynamicLocation = (e, { value }) => {
    const { onChange } = this.props;
    onChange(e, { dynamicLocation: value, location: null });
  };

  /**
   * handleChangeStaticLocation
   * Callback function when static location is changed.
   * @param { Object } e: The change event.
   * @param { Object } updatedProps: Updated props containing the updated lat and lon values.
   * @returns { void }
   */
  handleChangeStaticLocation = (e, { lat, lon }) => {
    const { onChange } = this.props;
    onChange(e, { dynamicLocation: undefined, location: { lat, lon } });
  };

  /**
   * handleToggleDynamic
   * Callback function when toggling between static and dynamic location.
   * @param { Object } e: The change event.
   * @param { Object } updatedProps: Updated props containing the updated value is dynamic option is selected.
   * @returns { void }
   */
  handleToggleDynamic = (e, updatedProps) => {
    const isCustomValue = updatedProps.value === ValueType.Custom;
    const orderBy = {
      dynamicLocation: isCustomValue ? undefined : '',
      location: isCustomValue ? DEFAULT_GEO_LOCATION : '',
    };
    this.props.onChange(e, orderBy);
  };

  render() {
    const { dynamicLocation, location } = this.props;
    const isDynamic = dynamicLocation !== undefined;
    let input;

    if (isDynamic) {
      input = (
        <StyledCoreDropdown
          search
          onChange={this.handleChangeDynamicLocation}
          options={this.getDropdownOptions()}
          placeholder={'Select...'}
          value={dynamicLocation}
        />
      );
    } else {
      const { lat, lon } = this.getLatLonFromLocation(location);
      input = <LocationPicker lat={lat} lon={lon} onChange={this.handleChangeStaticLocation} />;
    }

    return (
      <OrderByLocationPickerContainer>
        <StyledValueTypeDropdown
          onChange={this.handleToggleDynamic}
          showContactProperty
          value={this.getValueTypeDropdownValue(isDynamic)}
        />
        {input}
      </OrderByLocationPickerContainer>
    );
  }
}
